import {Injectable} from '@angular/core';
import {ApiUrlConstants} from '../../constants/api-url-constants';
import {httpConfig, HttpService} from '../http-service/http.service';
import {RequestParamModel} from '../../models/request-param-model';
import {HttpResponse} from '@angular/common/http';
import {PaginationModal} from '../../models/pagination-modal';
import {map} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SearchService {

    searchBaseUrlApi = ApiUrlConstants.SEARCH_BASE_URL;
    httpConfig: httpConfig;

    constructor(
        private _httpService: HttpService
    ) {
    }

    /**
     * Fetches search results from the API based on the provided parameters.
     * @param {RequestParamModel} input - The parameters required for the search request, which may include query filters, pagination, and sorting options.
      */
    search(input: RequestParamModel) {
        return this._httpService.get({url: this.searchBaseUrlApi, filterParameters: input})
            .pipe(
                map((response: HttpResponse<any>) => {
                    const searchList = new PaginationModal<any>();
                    const headers = response.headers;
                    searchList.setHeaders(headers);
                    searchList.data = response.body.data as any[];
                    return searchList;
                }, (err: any) => {
                    return err;
                })
            );
    }

    /**
     * Fetches search results from the API based on the provided parameters.
     * @param {RequestParamModel} input - The parameters to filter the search results.
     */
    searchResult(input: RequestParamModel) {
        return this._httpService.get({url: this.searchBaseUrlApi + '/results', filterParameters: input})
            .pipe(
                map((response: HttpResponse<any>) => {
                    const searchList = new PaginationModal<any>();
                    const headers = response.headers;
                    searchList.setHeaders(headers);
                    searchList.data = response.body.data as any[];
                    return searchList;
                }, (err: any) => {
                    return err;
                })
            );
    }
}
